import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.user;

export const userSelectors = {
  users: createSelector(selector, (state) => state.users),
};
